import { helper } from '@ember/component/helper';

/**
 * Returns argument after first truthy odd argument
 * @param {[ boolean, * ]} params
 * @return {*}
 */
export default helper(function ifElseHelper(params) {
  for (let i = 0, len = params.length; i < len; i += 2) {
    if (params[i]) {
      return params[i + 1];
    }
  }
});
